// @flow
import * as React from 'react'
import { getStaticSlugsPaths } from '../../../helpers/nextHelpers'
import type { SlugsStaticType } from '../../../helpers/nextHelpers'
import { withRouter } from 'next/router'
import { convertSeriesBySlugToProps, getSeriesSlugsAsync } from '../../../models/Series'
import type { SeriesPropsType } from '../../../models/Series'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { SeriesDetail } from '@components/Series/SeriesDetail'
function Series (props: SeriesPropsType): React.Node {
  return (
    <DiscoverLayout
      title={`Listen to the ${props.title} audiobook on Dipsea`}
      description={`Listen to the ${props.title} audiobook on Dipsea. ${props.description}`}
      imageUrl={props.images.img500}
      canonicalUrl={`https://www.dipseastories.com${props.slug.replace('series/', 'audiobooks/')}`}
    >
      <SeriesDetail {...props} />
    </DiscoverLayout>
  )
}

export default withRouter(Series)

type ContextType = {
  params: {
    slug: string
  }
}

export async function getStaticProps (
  context: ContextType
): Promise<{ props: SeriesPropsType }> {
  const series = await convertSeriesBySlugToProps(context.params.slug)
  return { props: series }
}
export async function getStaticPaths (): Promise<SlugsStaticType> {
  const slugs = await getSeriesSlugsAsync()
  return getStaticSlugsPaths(slugs)
}
